<template>
  <div>
    <b-row>
      <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
        <div class="sa-pianificazione-edit-container">
          <label for="">Giorni</label>
          <b-form-checkbox size="lg" class="sa-pianificazione-edit-container-selector" switch @input="onInputDaysAll"><label for="">Tutti</label></b-form-checkbox>
          <b-form-checkbox v-model="daysSelected" v-for="day in days" :key="day.code" :name="day.day" :value="day.code" size="lg" switch class="sa-pianificazione-edit-container-selector">
            <label for="">{{ day.day }}</label>
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
        <div class="sa-pianificazione-edit-container">
          <label for="">Orari</label>
          <div style="display: flex; flex-direction: row">
            <div style="flex: 1">
              <b-input-group class="mb-3">
                <date-picker format="HH:mm" value-type="timestamp" v-model="oraSelezionata" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time" :disabled="orarioDisabled"></date-picker>
              </b-input-group>
            </div>
            <div>
              <b-button size="sm" variant="outline-success  pull-right" style="height: 29px" @click="onClickAggiungiOrario()" :disabled="btnDisabledAggiungiOrario">
                <i class="fas fa-plus"></i>
              </b-button>
            </div>
          </div>
          <label class="sa-label-data">Ora Programmata:</label>
          <div v-for="(ora, index) in hoursSelected" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
            <div style="flex: 1; display: table">
              <span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)">
                {{ ora }}
              </span>
            </div>
            <div>
              <b-button size="sm" variant="outline-danger outline-secondary pull-right " @click="onClickRemoveOrario(index)" :disabled="btnDisabledAggiungiOrario">
                <i class="far fa-trash-alt"></i>
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
  mixins: [UtilityMixin],
  components: { DatePicker },
  data() {
    return {
      pianificazione: {},
      days: [],
      daysSelected: [],
      hoursSelected: [],
      btnDisabledAggiungiOrario: true,
      oraSelezionata: null,
      orarioDisabled: true,
    };
  },
  created() {
    this.days = UtilityMixin.methods.getDaysOfWeekArray();
  },
  mounted() {
    this.$emit("afterMounted");
  },
  watch: {
    daysSelected() {
      let me = this;
      me.pianificazione.giorni = me.daysSelected ? me.daysSelected.join(",") : "";
      this.$emit("updatePianificazioneOrario", me.pianificazione);
      if (me.daysSelected.length > 0) {
        me.orarioDisabled = false;
        me.btnDisabledAggiungiOrario = false;
      } else {
        me.hoursSelected = [];
        me.orarioDisabled = true;
        me.btnDisabledAggiungiOrario = true;
      }
    },
    hoursSelected() {
      let me = this;
      me.pianificazione.orari = me.hoursSelected ? me.hoursSelected.join(",") : "";
      this.$emit("updatePianificazioneOrario", me.pianificazione);
    },
  },
  methods: {
    getClass(index) {
      if (index % 2 === 0) {
        return "sa-utility-alternate-even";
      } else {
        return "sa-utility-alternate-odd";
      }
    },
    disbilitaOrePrecedenti(date) {
      let me = this;
      let today = new Date();
      let dataRiferimento = new Date(me.pianificazione.dataInizio);
      if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
        return date.getHours() < new Date().getHours();
      } else {
        return false;
      }
    },
    setPianificazione(pianificazione) {
      let me = this;
      me.pianificazione = pianificazione;
      me.daysSelected = pianificazione.giorni ? pianificazione.giorni.split(",") : [];
      me.hoursSelected = pianificazione.orari ? pianificazione.orari.split(",") : [];
    },
    onInputDaysAll(value) {
      let me = this;
      me.daysSelected = [];
      if (value) {
        this.days.forEach((element) => {
          me.daysSelected.push(element.code);
        });
      }
    },
    onClickRemoveOrario(index) {
      let me = this;
      me.hoursSelected.splice(index, 1);
    },
    onClickAggiungiOrario() {
      let me = this;
      if (this.oraSelezionata) {
        me.hoursSelected.push(me.formatTime(this.oraSelezionata));
        me.hoursSelected = [...new Set(me.hoursSelected)];
        me.hoursSelected.sort();
      }
    },
  },
};
</script>

<style></style>
